import { MAX_FLOW_NAME_LENGTH, type KioskFlowOperatorContext } from '../types/kiosk-flow-types';

export function assertOperator(ctx: KioskFlowOperatorContext): void {
  if (!ctx.operatorId || ctx.operatorId <= 0) {
    throw new Error('An operator must be selected');
  }
}

// Returns the trimmed name, or throws when it breaks the name rules
export function validateFlowName(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) {
    throw new Error('Flow name is required');
  }
  if (trimmed.length > MAX_FLOW_NAME_LENGTH) {
    throw new Error(`Flow name must be at most ${MAX_FLOW_NAME_LENGTH} characters`);
  }
  return trimmed;
}
